export enum ChmodEnum {
  Default = '',
  NoAccess = '0',
  Read = '4',
  ReadWrite = '6'
}
